export const programmeTypeGroupFieldsInfo = {
  MBA: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: true },
    yearsManagerialExperience: { enabled: false },
    companyName: { enabled: true },
    industry: { enabled: true },
    function: { enabled: true },
    seniorityLevel: { enabled: true },
    university: { enabled: false },
    studyDiscipline: { enabled: false },
    graduationYear: { enabled: false },
    grade: { enabled: false },
    gmatScore: { enabled: true },
    executiveAssessmentScore: { enabled: false },
    intendedYearOfStudy: { enabled: true },
    programmeSection: { enabled: false },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  MAM: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: true },
    yearsManagerialExperience: { enabled: false },
    companyName: { enabled: false },
    industry: { enabled: false },
    function: { enabled: false },
    seniorityLevel: { enabled: false },
    university: { enabled: true },
    studyDiscipline: { enabled: false },
    graduationYear: { enabled: true },
    grade: { enabled: true },
    gmatScore: { enabled: false },
    executiveAssessmentScore: { enabled: false },
    intendedYearOfStudy: { enabled: false },
    programmeSection: { enabled: false },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  MIF: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: true },
    yearsManagerialExperience: { enabled: false },
    companyName: { enabled: true },
    industry: { enabled: true },
    function: { enabled: true },
    seniorityLevel: { enabled: true },
    university: { enabled: false },
    studyDiscipline: { enabled: false },
    graduationYear: { enabled: false },
    grade: { enabled: false },
    gmatScore: { enabled: true },
    executiveAssessmentScore: { enabled: false },
    intendedYearOfStudy: { enabled: true },
    programmeSection: { enabled: true },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  MIM: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: true },
    yearsManagerialExperience: { enabled: false },
    companyName: { enabled: false },
    industry: { enabled: false },
    function: { enabled: false },
    seniorityLevel: { enabled: false },
    university: { enabled: true },
    studyDiscipline: { enabled: false },
    graduationYear: { enabled: true },
    grade: { enabled: true },
    gmatScore: { enabled: false },
    executiveAssessmentScore: { enabled: false },
    intendedYearOfStudy: { enabled: false },
    programmeSection: { enabled: true },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  MFA: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: true },
    yearsManagerialExperience: { enabled: false },
    companyName: { enabled: false },
    industry: { enabled: false },
    function: { enabled: false },
    seniorityLevel: { enabled: false },
    university: { enabled: true },
    studyDiscipline: { enabled: true },
    graduationYear: { enabled: true },
    grade: { enabled: true },
    gmatScore: { enabled: false },
    executiveAssessmentScore: { enabled: false },
    intendedYearOfStudy: { enabled: false },
    programmeSection: { enabled: false },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  EMBA: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: false },
    yearsManagerialExperience: { enabled: true },
    companyName: { enabled: false },
    industry: { enabled: false },
    function: { enabled: false },
    seniorityLevel: { enabled: true },
    university: { enabled: false },
    studyDiscipline: { enabled: false },
    graduationYear: { enabled: false },
    grade: { enabled: false },
    gmatScore: { enabled: true },
    executiveAssessmentScore: { enabled: true },
    intendedYearOfStudy: { enabled: true },
    programmeSection: { enabled: true },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  EMBAG: {
    emailAddress: { enabled: true },
    countryNumber: { enabled: false },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: false },
    yearsManagerialExperience: { enabled: false },
    companyName: { enabled: false },
    industry: { enabled: false },
    seniorityLevel: { enabled: false },
    university: { enabled: false },
    graduationYear: { enabled: false },
    programmeSection: { enabled: false },
    hrInformation: { enabled: false },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
  SLOAN: {
    emailAddress: { enabled: true },
    title: { enabled: true },
    firstName: { enabled: true },
    lastName: { enabled: true },
    telephoneNumber: { enabled: true },
    nationalityOf: { enabled: true },
    countryOfResidence: { enabled: true },
    countryState: { enabled: true },
    city: { enabled: true },
    yearsRelevanceExperience: { enabled: false },
    yearsManagerialExperience: { enabled: true },
    companyName: { enabled: false },
    industry: { enabled: false },
    function: { enabled: false },
    seniorityLevel: { enabled: true },
    university: { enabled: false },
    studyDiscipline: { enabled: false },
    graduationYear: { enabled: false },
    grade: { enabled: false },
    gmatScore: { enabled: true },
    executiveAssessmentScore: { enabled: true },
    intendedYearOfStudy: { enabled: true },
    programmeSection: { enabled: false },
    linkedInProfileURL: { enabled: true },
    uploadCV: { enabled: true },
    password: { enabled: true },
    confirmPassword: { enabled: true },
  },
};

export const permanentFields = [
  "emailAddress",
  "title",
  "firstName",
  "lastName",
];

export const programmesListData = {
  MIM: [
    {
      id: "10001",
      name: "Masters in Management",
      value: "MIM",
    },
    {
      id: "10002",
      name: "Global MiM",
      value: "GMIM",
    },
  ],
  MIF: [
    {
      id: "10003",
      name: "Masters in Finance Full-time",
      value: "MIFFT",
    },
    {
      id: "10004",
      name: "Masters in Finance Part-time",
      value: "MIFPT",
    },
  ],
  EMBA: [
    //EMBA London blended, EMBA London in-person, EMBA Dubai blended, EMBA Dubai in-person
    {
      id: "10005",
      name: "Executive MBA London-In-person",
      value: "EMBA London in-person",
    },
    {
      id: "10006",
      name: "Executive MBA London-Blended (In-person & Online)",
      value: "EMBA London blended",
    },
    {
      id: "10007",
      name: "Executive MBA Dubai-In-person",
      value: "EMBA Dubai in-person",
    },
    {
      id: "10008",
      name: "Executive MBA Dubai-Blended (In-person & Online)",
      value: "EMBA Dubai blended",
    },
  ],
};
